import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales';
import h from 'virtual-dom/h';
import Inputmask from 'inputmask';
import ko from 'knockout';
import 'knockout.validation';
import flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';

import { listviewDefaults, listviewColumnActionDefaults, listviewRenderTypeDefaults } from './listview';
import './custom-packages/knockout-file-bindings/knockout-file-bindings';
import './knockout.bindings';

moment.locale('nl-nl');
numeral.locale('nl-nl');
flatpickr.localize(Dutch);

listviewDefaults.tableProps = { className: 'table-bordered table-bordered-light' };
listviewDefaults.noResults = () => 'Geen resultaten';
listviewColumnActionDefaults.popupProps = { className: 'popup' };
listviewColumnActionDefaults.confirmTitle = 'Bevestig';
listviewColumnActionDefaults.confirmButtonProps = { className: 'btn btn-primary btn-normal btn-rounded pull-right' };
listviewColumnActionDefaults.cancelButtonProps = { className: 'btn btn-normal btn-rounded pull-right' };
listviewColumnActionDefaults.cancelHeaderButtonProps = { className: 'icon icon-normal icon-close-o' };
listviewColumnActionDefaults.confirmButtonContent = 'Bevestigen';
listviewColumnActionDefaults.cancelButtonContent = 'Annuleren';

listviewRenderTypeDefaults.datetime = (value: string, format: any) => {
    var date = moment(value);
    var formattedDate = date.format(format);
    return formattedDate;
};
listviewRenderTypeDefaults.number = (value: number, format: any) => {
    var num = numeral(value);
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}
listviewRenderTypeDefaults.currency = (value: number, format: any) => {
    var num = numeral(value);
    format = `$${format}`;
    var formattedNumeral = num.format(format);
    return formattedNumeral;
}

[].forEach.call(document.getElementsByClassName('integer'), (element: any) => {
    Inputmask('integer', {
        rightAlign: false,
        autoGroup: true,
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('decimal'), (element: any) => {
    Inputmask('decimal', {
        rightAlign: false,
        autoGroup: true,
        digits: 2,
        radixPoint: ',',
        groupSeparator: '.'
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('date'), (element: any) => {
    Inputmask('dd-mm-yyyy', {
        placeholder: 'dd/mm/jjjj',
        clearMaskOnLostFocus: false
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('datetime'), (element: any) => {
    Inputmask('datetime', {
        placeholder: 'dd/mm/jjjj uu:mm',
        clearMaskOnLostFocus: false
    }).mask(element);
});

[].forEach.call(document.getElementsByClassName('time'), (element: any) => {
    Inputmask('hh:mm:ss', {
        placeholder: "uu:mm'ss",
        clearMaskOnLostFocus: false
    }).mask(element);
});

(<any>ko).fileBindings.defaultOptions.noFileText = 'Geen afbeelding gekozen';
(<any>ko).fileBindings.defaultOptions.buttonText = 'Kies afbeelding';
(<any>ko).fileBindings.defaultOptions.changeButtonText = 'Aanpassen';
(<any>ko).fileBindings.defaultOptions.clearButtonText = 'Wis';
(<any>ko).fileBindings.defaultOptions.buttonClass = 'btn btn-primary btn-normal';
(<any>ko).fileBindings.defaultOptions.clearButtonClass = 'btn btn-gray btn-normal';

ko.validation.init({
    decorateInputElement: true,
    errorMessageClass: 'form-error',
    errorElementClass: 'isfalse'
});

ko.validation.insertValidationMessage = (element: Element) => {
    let span = document.createElement('span');
    span.className = ko.validation.utils.getConfigOptions(element).errorMessageClass || '';
    const parentGroup = element.closest('.input-group') || element;
    ko.validation.utils.insertAfter(parentGroup, span);

    return span;
}

const html = document.documentElement;
const popups = <HTMLElement[]>Array.from(document.getElementsByClassName('popup'));
const popupToggles = <HTMLElement[]>Array.from(document.getElementsByClassName('toggle-popup'));
const popupCloses = <HTMLElement[]>Array.from(document.getElementsByClassName('close-popup'));
const backfaces = <HTMLElement[]>Array.from(document.getElementsByClassName('backface'))
    .filter((element) => !element.classList.contains('no-close'));

popupToggles.forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();

        let toggleId = element.dataset.toggle;
        if (toggleId) {
            if (toggleId.startsWith('#')) {
                toggleId = toggleId.substring(1);
            }

            const target = document.getElementById(toggleId);
            if (target) {
                html.classList.add('popup-open');
                target.classList.add('open');
                html.querySelector('.backface')!.classList.add('open');
            }
        }
    });
});

[...popupCloses, ...backfaces].forEach(element => {
    element.addEventListener('click', (e: Event) => {
        e.preventDefault();
        closePopups();
    });
});

export function closePopups() {
    html.classList.remove('popup-open');
    popups.forEach(popup => popup.classList.remove('open'));
    backfaces.forEach(backface => backface.classList.remove('open'));
}

export function openPopup(name: string) {
    const target = document.getElementById(name);

    if (target) {
        document.documentElement.classList.add('popup-open');
        target.classList.add('open');
        document.documentElement.querySelector('.backface')!.classList.add('open');
    }
}

const dropdownButtons = <HTMLElement[]>Array.from(document.getElementsByClassName('dropdown-button'));
dropdownButtons.forEach(dropdown => {
    dropdown.addEventListener('click', (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        dropdown.parentElement?.querySelector('.dropdown-content')?.classList.toggle('show');
    });
});

// Close the dropdown if the user clicks outside of it
window.onclick = (event: any) => {
    dropdownButtons
        .forEach(dropdown => {
            const dropdownContent = dropdown.parentElement?.querySelector('.dropdown-content')!;
            if (!dropdownContent.contains(event.target)
                && dropdownContent.classList.contains('show')) {
                dropdownContent.classList.remove('show');
            }
        })
}
